import { Document } from "@/models/document";
import { DocumentAPI } from "@/api/document.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Viproc } from "@/models/viproc";
import { ProcessoArce } from "@/models/processoArce";

export interface Processo {
  type: string;
  numero: string;
}

const documentApi = new DocumentAPI();

const findByViprocOrNumeroArce = (
  process: Processo,
  recaptcha: string
): AxiosObservable<Document> => {
  if (process.type === "viproc") {
    const split = process.numero.split("/");
    const number = Number(split[0]);
    const year = Number(split[1]);
    const viproc = new Viproc(number, year);

    return documentApi.findByViproc(viproc, recaptcha);
  } else {
    const split = process.numero.split("/");
    const number = Number(split[2]);
    const year = Number(split[3]);
    const especie = String(split[0]).toLocaleUpperCase();
    const setor = String(split[1]).toLocaleUpperCase();

    // Cambiarra para consertar a gambiarra do SISCDO
    // eu não queria fazer isso maass!!
    // let especieCustom = "";
    // if (especie.length == 2) {
    //   especieCustom += `${especie}  `; // não remover esse espaço final da interpolação
    // } else if (especie.length == 3) {
    //   especieCustom += `${especie} `; // não remover esse espaço final da interpolação
    // } else {
    //   especieCustom = especie;
    // }

    const processoArce = new ProcessoArce(
      number,
      year,
      especie,
      setor,
      recaptcha
    );
    return documentApi.findByNumeroArce(processoArce);
  }
};

export default { findByViprocOrNumeroArce };
